const setNativeValue = (element: HTMLInputElement, value: string) => {
  const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set;
  const prototype = Object.getPrototypeOf(element);
  const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

  if (valueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter?.call(element, value);
  } else {
    valueSetter?.call(element, value);
  }
};

const setInputElementValue = (inputElement: HTMLInputElement, value: string) => {
  setNativeValue(inputElement, value);

  inputElement.dispatchEvent(new Event('input', { bubbles: true }));
};

export { setInputElementValue };
